import api from "./api";
import log from "loglevel";

const state = {
  ogps: []
};

// getters
const getters = {};

// actions
const actions = {
  async getOgpFromContent(context, { id, content }) {
    const urlPattern = /(https?:\/\/[^<>\s\r\n\t]+)/g;

    const urls = content.match(urlPattern);

    if (urls == null) {
      return;
    }

    context.commit("initializeOgp", { id: id });
    urls.forEach(async (url, index) => {
      try {
        const res = await api.postOgp({ url: url });
        context.commit("updateOgp", { id: id, index: index, ogp: res.data });
      } catch (error) {
        log.error("postOgp error:", error);
        context.commit("common/setError", error, { root: true });
      }
    });
  }
};

// mutations
const mutations = {
  initializeOgp(state, { id }) {
    state.ogps = [
      ...state.ogps.filter(ogp => ogp.id != id),
      { id: id, ogps: [] }
    ];
  },
  updateOgp(state, { id, index, ogp }) {
    let ogpItem = state.ogps.find(o => o.id == id);

    if (!ogpItem) {
      ogpItem = { id: id, ogps: [] };
    }

    ogpItem.ogps[index] = ogp;
    state.ogps = [...state.ogps.filter(ogp => ogp.id != id), ogpItem];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
